import script from "./OrgCareView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgCareView.vue?vue&type=script&setup=true&lang=js"

import "./OrgCareView.vue?vue&type=style&index=0&id=5aa40a47&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa40a47"]])

export default __exports__